import React, { useEffect, useState } from "react";
import { useDisclosure } from "@heroui/react";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useLocation, useNavigate  } from 'react-router-dom';

import MainContent from "./components/MainContent";
import Distributors from './components/Distributors';
import WhyUse from "./components/WhyUse";
import EasyTools from "./components/EasyTools";
import HowBomSearchWorks from "./components/HowBomSearchWorks";
import EngineerSaid from "./components/EngineerSaid";
import JoinBeta from "./components/JoinBeta";
import LoginModal from "src/shared/components/LoginModal";

const HomePage = () => {
  const [modalMode, setModalMode] = useState("LOGIN");
  const {isOpen: isModalOpen, onOpen: onModalOpen, onOpenChange: onModalOpenChange} = useDisclosure();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/login") {
      navigate("/");
      setModalMode("LOGIN");
      onModalOpen();
    } else if (location.pathname === "/signup") {
      navigate("/");
      setModalMode("SIGNUP");
      onModalOpen();
    }
  }, [location.pathname, location.search]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <div id="welcome">
        <MainContent />
        <Distributors />
        <WhyUse />
        <EasyTools />
        <HowBomSearchWorks />
        <EngineerSaid />
        <JoinBeta />
      </div>

      <LoginModal
        mode={modalMode}
        isOpen={isModalOpen}
        onOpenChange={onModalOpenChange}
        onOk={() => {}}
      />
    </GoogleReCaptchaProvider>
  );
};

export default HomePage;